// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"2057":"e70e9366","5415":"9e3e4484"}[chunkId] + ".chunk.js");